import pizza from '../../assets/img/pizza.svg';
import taco from '../../assets/img/taco.svg';
import burger from '../../assets/img/burger.svg';
import sushi from '../../assets/img/sushi.svg';

const data = [
  {
    title: 'Italian',
    image: pizza,
  },
  {
    title: 'Mexican',
    image: taco,
  },
  {
    title: 'American',
    image: burger,
  },
  {
    title: 'Japanese',
    image: sushi,
  },
];

export default data;
